<template>
  <div class="content-wrapper purchase-plan">
    <section class="content">
      <a-alert :message="$t('采购计划介绍')" type="info" show-icon style="margin-bottom: 10px" />
      <div class="form-content" @keydown="enterPress">
        <a-row :gutter="16" class="flex-row">
          <a-col :span="6">
            <SelectWarehouseNew :code.sync="searchData.warehouseCode" />
          </a-col>
          <a-col :span="6">
            <a-input
              allowClear
              :placeholder="$t('请输入商家编码/商品条码')"
              v-model="searchData.keys"
            ></a-input>
          </a-col>
          <a-col :span="6">
            <!-- 商品类目选项 -->
            <CategoryList @handleCategoryChange="handleCategoryChange" />
          </a-col>
          <a-col :span="6">
            <!-- 商品类目选项 -->
            <a-input-number
              style="width: 100%"
              v-model="searchData.inventoryAvailableDays"
              :placeholder="$t('库存可用天数')"
            />
          </a-col>
          <a-col :span="6" class="mt10">
            <a-select
              :placeholder="$t(`商品类型`)"
              v-model="searchData.goodsType"
              style="width: 100%"
            >
              <a-select-option :value="key" v-for="(item, key) in goodsTypeMapping" :key="key">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="mt10">
            <a-select
              :placeholder="$t(`销售类型`)"
              v-model="searchData.saleType"
              style="width: 100%"
            >
              <a-select-option :value="key" v-for="(item, key) in saleTypeMapping" :key="key">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="mt10">
            <a-input-group compact class="inputSearch">
              <a-input
                v-model="searchData.minSuggestedPurchaseQuantity"
                style="width: 45%; text-align: center"
                :placeholder="$t(`建议采购下限`)"
              />
              <a-input
                class="site-input-split"
                style="width: 10%; border-left: 0; pointer-events: none"
                placeholder="~"
                disabled
              />
              <a-input
                v-model="searchData.maxSuggestedPurchaseQuantity"
                class="site-input-right"
                style="width: 45%; text-align: center"
                :placeholder="$t(`建议采购上限`)"
              />
            </a-input-group>
          </a-col>
          <a-col :span="6" class="mt10">
            <a-select
              mode="multiple"
              v-model="searchData.excludeTypeList"
              style="width: 100%"
              :placeholder="$t('排除类型')"
            >
              <a-select-option value="sample">
                {{ $t('寄样') }}
              </a-select-option>
              <a-select-option value="b2b">
                {{ $t('B2B') }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="mt10">
            <!-- 查询导出按钮 -->
            <a-button @click="getTableList(1)" type="primary" icon="search">
              {{ $t(`form.Search`) }}
            </a-button>
            <a-button @click="showExportVisible = true" icon="upload">
              {{ $t(`form.Export`) }}
            </a-button>
          </a-col>
        </a-row>
      </div>
      <div class="table-content">
        <div class="table-header">
          <a-button @click="createPRHandle" type="primary">
            {{ $t(`创建采购申请单`) }}
          </a-button>
        </div>
        <div class="table-body">
          <a-table
            :loading="loading"
            :columns="columns"
            :data-source="tableList"
            :scroll="{ x: 2400, y: tableHeight }"
            :pagination="false"
            :rowKey="(record, index) => record.barcode + ',' + index"
            bordered
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
          >
            <span slot="productName" slot-scope="text, record">
              <div class="flex">
                <img
                  v-if="record.skuImage"
                  class="mr10"
                  :src="record.skuImage"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
                <div>
                  <div v-if="record.skuName">{{ $t('名称') }}: {{ record.skuName }}</div>
                  <div v-if="record.barcode">{{ $t('条码') }}: {{ record.barcode }}</div>
                  <div v-if="record.skuCodeList">
                    {{ $t('编码') }}: {{ record.skuCodeList?.join(',') }}
                  </div>
                </div>
              </div>
            </span>
            <span slot="categoryList" slot-scope="text, record">
              <div>{{ record.categoryList?.[0] }}</div>
              <div>
                {{ record.saleTypeName }}(
                <span>{{ record.goodsTypeName }}</span>
                )
              </div>
            </span>
            <template v-for="col in customRenderList" v-slot:[col]="text, record">
              <div :key="col">
                <!-- includes 用来判断当前的输入类型 -->
                <MulUnitShow :list="record.unitVoList" :amount="text" />
              </div>
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <Pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="totalCount"
            @paginate="paginate"
          />
        </div>
      </div>
    </section>

    <a-modal
      :visible="showExportVisible"
      :title="$t('选择导出单位')"
      @cancel="showExportVisible = false"
      @ok="onExport"
    >
      <a-form-model>
        <a-form-model-item :label="$t('选择单位')">
          <SelectUnitType :value.sync="unitType" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CategoryList from '@/component/categoryList'
import Pagination from '@/component/pagination'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import MulUnitShow from '@component/mulUnitShow'
import SelectUnitType from '@component/selectUnitType'
import { getUnitRate } from '@/common'

export default {
  name: 'purchasePlan',
  components: { CategoryList, Pagination, SelectWarehouseNew, MulUnitShow, SelectUnitType },
  data() {
    return {
      loading: false,
      searchData: {
        keys: undefined,
        categoryId: undefined,
        categoryName: undefined,
        warehouseCode: undefined,
        inventoryAvailableDays: undefined,
        excludeTypeList: [],
      },
      pageNo: 1,
      pageSize: 10,
      tableList: [],
      selectedRowKeys: [],
      selectedRows: [],
      totalCount: 0,
      showExportVisible: false,
      unitType: undefined,
    }
  },
  computed: {
    ...mapState(['goodsTypeMapping', 'saleTypeMapping']),
    customRenderList() {
      return [
        'waitDeliveryQuantity',
        'realQuantity',
        'inTransitQuantity',
        'fifteenSalesQuantity',
        'thirtySalesQuantity',
        'fifteenAvgQuantity',
        'thirtyAvgQuantity',
      ]
    },
    columns() {
      return [
        {
          title: this.$t('商品信息'),
          width: 300,
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          title: this.$t('规格值'),
          dataIndex: 'skuStyleList',
          customRender: (text) => text?.join(','),
        },
        {
          title: this.$t('商品类型'),
          dataIndex: 'categoryList',
          width: 150,
          scopedSlots: {
            customRender: 'categoryList',
          },
        },
        {
          title: this.$t('当日期初库存'),
          dataIndex: 'realQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'realQuantity',
          },
        },
        {
          dataIndex: 'inventoryAvailableDays',
          title: this.$t('库存可用天数'),
        },
        {
          title: this.$t('待发货数量'),
          dataIndex: 'waitDeliveryQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'waitDeliveryQuantity',
          },
        },
        {
          title: this.$t('在途库存'),
          dataIndex: 'inTransitQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'inTransitQuantity',
          },
        },
        {
          title: this.$t('15天出库数量'),
          dataIndex: 'fifteenSalesQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'fifteenSalesQuantity',
          },
        },
        {
          title: this.$t('30天出库数量'),
          dataIndex: 'thirtySalesQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'thirtySalesQuantity',
          },
        },
        {
          dataIndex: 'fifteenAvgQuantity',
          title: this.$t('15天日均出库数量'),
          width: 120,
          scopedSlots: {
            customRender: 'fifteenAvgQuantity',
          },
        },
        {
          dataIndex: 'thirtyAvgQuantity',
          title: this.$t('30天日均出库数量'),
          width: 120,
          scopedSlots: {
            customRender: 'thirtyAvgQuantity',
          },
        },
        {
          dataIndex: 'arrivalPeriod',
          title: this.$t('到货周期（天）'),
        },
        {
          dataIndex: 'isAvailableDaysShortage',
          title: this.$t('库存可用天数是否小于到货周期'),
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          dataIndex: 'lastPurchaseSupplier',
          title: this.$t('最后一次采购供应商'),
        },
        {
          title: this.$t('最后一次采购单价'),
          dataIndex: 'lastPurchaseRawUnitPrice',
          customRender: (text, record) => text && text + '/' + record.lastProcurementUnit,
        },
        {
          title: this.$t('税率'),
          dataIndex: 'vatRate',
        },
        {
          title: this.$t('发票类型'),
          dataIndex: 'invoiceType',
        },
        {
          title: this.$t('仓库'),
          dataIndex: 'warehouseName',
        },
        {
          title: this.$t('建议采购数量'),
          dataIndex: 'suggestedPurchaseQuantity',
        },
      ]
    },
    tableHeight() {
      return (window.innerHeight - 420) * this.$store.state.rate
    },
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    reset() {
      this.searchData = {
        keys: undefined,
        categoryId: undefined,
        categoryName: undefined,
        inventoryAvailableDays: undefined,
      }
      this.pageNo = 1
      this.pageSize = 10
      this.tableList = []
      this.selectedRowKeys = []
    },
    enterPress() {
      var e = event || window.event
      this.pageNo = 1
      if (e.keyCode == 13) {
        this.getTableList()
      }
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.getTableList()
    },
    async getTableList(first_page = false) {
      this.tableList = []
      first_page && (this.pageNo = 1)
      this.loading = true
      let res = await http({
        url: api.queryProcurementPlanList,
        type: 'post',
        data: {
          ...this.searchData,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          buId: this.$store.getters.partyId,
        },
        hasLoading: true,
      })
      this.tableList = res.result.procurementPlanList
      this.totalCount = res.result.total
      this.loading = false
    },
    handleCategoryChange(data) {
      this.searchData.categoryId = data?.categoryId
      this.searchData.categoryName = data?.categoryName
    },
    // 选择导出的行
    onSelectChange(selectedRowKeys, selectedRows) {
      this.tempRowKeys = []
      selectedRowKeys.forEach((v) => {
        this.tempRowKeys.push(v.split(',')[0])
      })
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 导出
    onExport() {
      if (!this.unitType) {
        this.$message.warning(this.$t('选择导出单位'))
        return
      }
      let currentShop = this.$store.state.currentShop
      let mergeCode = currentShop.uniqueCode
      let merchantShopName = currentShop.name
      let merchantCode = this.$store.state.userSession.merchantCode
      let data = {
        ...this.searchData,
        unitType: this.unitType,
        buId: this.$store.getters.partyId,
      }
      http({
        type: 'post',
        url: api.taskCreate,
        hasLoading: true,
        data: {
          bookCode: 'procurementPlanExport',
          mergeCode,
          merchantShopName,
          appCode: 'OMS',
          params: {
            merchantCode,
            ...data,
          },
        },
        success: () => {
          this.$message.success(this.$t('导出成功'))
          this.showExportVisible = false
        },
        error: (err) => {
          this.$error({
            title: this.$t(`layer.Error`),
            content: err.msg,
          })
        },
      })
    },
    createPRHandle() {
      //带信息去创建采购单页面
      //商品条码列表（供应商、库存、采购数量）
      if (this.selectedRows.length === 0) {
        return this.$message.warning(this.$t('layer.SelectAtLeastOneItem'))
      }
      //不同仓库报错 只有相同仓库才能创建采购申请单
      let hasDiffWarehouse = true
      let currentWarehouseCode = this.selectedRows[0].warehouseCode
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (this.selectedRows[i].warehouseCode !== currentWarehouseCode) {
          hasDiffWarehouse = false
        }
      }
      if (!hasDiffWarehouse) {
        return this.$message.warning(this.$t('选中不同的仓库，不能创建采购申请单'))
      }

      //建议采购数量suggestedPurchaseQuantity 基准单位的 去生成采购申请单的时候数量quantity需要转换成采购单位 向上取整
      const data = this.selectedRows.map((item) => {
        let targetUnit = item.unitVoList.find((item) => item.procurementUnit) || {}
        let { rate } = getUnitRate({ list: item.unitVoList, targetUnit })
        const data = {
          skuName: item.skuName,
          barcode: item.barcode,
          skuCode: item.skuCodeList[0],
          quantity: Math.ceil(item.suggestedPurchaseQuantity / rate),
          stock: Math.floor(item.realQuantity / rate),
          supplierCode: item.lastPurchaseSupplierCode,
          supplierName: item.lastPurchaseSupplier,
          unit: item.lastProcurementUnit,
          warehouseCode: item.warehouseCode,
          vatRate: item.vatRate,
        }
        console.log('data: ', data)
        return data
      })

      localStorage.setItem('purchasePlanInfo', JSON.stringify(data))
      this.$router.push({
        name: 'createPurchaseRequest',
      })
    },
  },
}
</script>
